// Helper for React-Snap prerendering with safeguards for environments where it's not used

// Safe accessor for window to avoid SSR issues
const getWindow = (): (Window & typeof globalThis) | undefined => {
  return typeof window !== 'undefined' ? window : undefined;
};

export const snapSaveState = () => {
  const win = getWindow();
  if (!win) return;
  
  // Save the data you need to hydrate your app
  (win as any).snapSaveState = () => {
    return {
      // Add anything you want to save from your app's state
      __PRERENDERED: true
    };
  };
};

export const isPrerendered = (): boolean => {
  const win = getWindow();
  if (!win) return false;
  
  return !!(win as any).__PRERENDERED;
};
